<template>
  <div class="w3ls-banner">
    <div :class="d._class" :id="d._title">
      <div class="container">
        <h3>{{d._title}}</h3>
        <p class="paragraph" style="font-size:1.5em;margin: 2% 0;" v-for="(x,i) of d.paragraphs" :key="i" v-html="x"></p>

        <p style="font-size: 1.5em;margin-bottom: 5%;color:crimson">
          Submission Page:
          <b>
            <a :href="d.submissionPageUrl" style="color:crimson">click here</a>
          </b>
        </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Submission",
  props: {
    datum: {
      type: Object,
      default: function() {
        return {
          paragraphs: [],
          submissionPageUrl: ""
        };
      }
    }
  },
  data() {
    return {
      d: {
        _class: "team colored-bg",
        _title: "Submission",

        ...this.datum
      }
    };
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Submission.vue